/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {  DataGridCustom, Grid, Table, Button } from '../../../components/index';
import ProtectedItem from '../../../components/ComponentesAutenticacao/ProtectedItem';
import { formatarCnpj } from '../../../utils/helpers';

const pemissoesAcaoPrincipal = ['analisar-compensacao-rpps', 'requerer-compensacao-rpps'];
class MultiplasDestinacoes extends Component {
  constructor() {
    super();
    const initialState = this.getInitialState();
    this.state = initialState;
  }

  getInitialState = () => ({})

  deleteItem = (row) => {
    this.props.handleExcluirDestinacao(row);
  }

  popularDestinacaoAlteracao = (destinacaoAlterar) => {
    this.setState({ ctcDestinacao: destinacaoAlterar });
  }

  alterarItem = (row) => {
    this.props.handleCarregarAlteracaoDestinacao(row);
  }

  detalharItem = (row) => {
    this.props.handleCarregarDetalhamentoDestinacao(row);
  }

  desabilitarBotaoExcluir = (indice) => {
    const { linhasDestinacaoDesabilitar } = { ...this.props.statePrincipal };
    let retorno = false;
    if (linhasDestinacaoDesabilitar !== null && linhasDestinacaoDesabilitar !== undefined &&
      (linhasDestinacaoDesabilitar.length > 0 && linhasDestinacaoDesabilitar.includes(indice))) {
      retorno = true
    }
    return retorno;
  }

  createActionColumn = index => (
    <React.Fragment>
      {this.exibirBotaoAlterar() &&
        <Button
          hint="Alterar"
          icon="ico-pencil"
          mini
          onClick={() => this.alterarItem(index)}
        />
      }
      {this.exibirBotoesPadrao() &&
        <Button
          className="dtp-inverse"
          hint="Excluir"
          icon="ico-hourglass-minus"
          mini
          disabled={this.desabilitarBotaoExcluir(index)}
          onClick={() => this.deleteItem(index)}
        />
      }
      {this.exibirBotaoDetalhar() &&
        <Button
          hint="Detalhar"
          icon="ico-magnifier"
          mini
          onClick={() => this.detalharItem(index)}
          disabled={(this.props.desabilitarBotaoAlterar === index) || this.props.desabilitarListaBotoes}
        />
      }
    </React.Fragment>
  );

  createCustomInsertButton = () => {
    return (
      <ProtectedItem allowedPermissions={pemissoesAcaoPrincipal}>
        {this.props.verificarExibicaoBotaoIncluirDestinacao() &&
          <React.Fragment>
            <Button
              className="dtp-primary left"
              onClick={this.showModalDestinacao}
              hint="incluir destinatário"
              icon='ico-plus'
            />
          </React.Fragment>
        }
      </ProtectedItem>
    );
  }

  options = {
    hideSizePerPage: true,
    insertBtn: this.createCustomInsertButton,
    noDataText: 'Nenhum destinatário foi adicionado à lista.',
    sizePerPage: 5,
  };

  fetchInfo = {};

  handleChange = (changeObj, name) => {
    const id = this.props.id;
    let valor = changeObj.value;
    switch (id) {
      case 1:
        let { ctcAtividadeAfastamento } = { ...this.state };
        this.setState({
          ctcAtividadeAfastamento: {
            ...ctcAtividadeAfastamento,
            [name]: valor,
          },
        });
        break;
      case 2:
        let { ctcAtividadeTempoCertificado } = { ...this.state };
        this.setState({
          ctcAtividadeTempoCertificado: {
            ...ctcAtividadeTempoCertificado,
            [name]: valor,
          },
        });
        break;
      case 3:
        let { ctcAtividadeTempoEspecial } = { ...this.state };
        this.setState({
          ctcAtividadeTempoEspecial: {
            ...ctcAtividadeTempoEspecial,
            [name]: valor,
          },
        });
        break;
      default:
        break;
    }
  }

  alteraListaAposExclusao = (lista) => {
    this.props.handleChange({ value: lista, isValid: lista.length > 0 }, 'destinacoes');
  }

  colunasDefault = [
    {
      id: 'indiceVisualizacao',
      label: '#',
    },
    {
      id: 'nomeParticipante',
      label: 'Participante',
    },
    {
      id: 'nomeOrgao',
      label: 'Orgão',
    },
    {
      id: 'cnpj',
      label: 'CNPJ',
      dataFormat: formatarCnpj,
    },
  ];

  montaColunasEspecificas = () => {
    let colunaMatricula = [{
        id: 'matricula',
        label: 'Matrícula',
      }];
    return colunaMatricula;
  };

  montaColunas = () => {
    let tableHeader = this.colunasDefault.slice();
    const colunasEspecificas = this.montaColunasEspecificas();
    if (colunasEspecificas) {
      tableHeader = tableHeader.concat(colunasEspecificas);
    }
    if((!['detalhar-ctc', 'detalhar-ctc-invalida'].includes(this.props.statePrincipal.acao))){
      tableHeader.push({
        id: 'indice',
        label: 'Ações',
        dataFormat: this.createActionColumn,
      });
    }

    if((['detalhar-ctc', 'detalhar-ctc-invalida'].includes(this.props.statePrincipal.acao))){
      tableHeader.push({
        id: 'indice',
        label: 'Ações',
        dataFormat: this.createActionColumn,
      });
    }
    return tableHeader;
  }

  exibirBotaoAlterar = () => (
    (this.props.statePrincipal !== 'criado' && ['novo', 'editar-rascunho', 'revisar-ctc'].includes(this.props.statePrincipal.acao))
  );

  exibirBotoesPadrao = () => (
    (this.props.statePrincipal !== 'criado' && ['novo', 'editar-rascunho', 'revisar-ctc'].includes(this.props.statePrincipal.acao))
  );

  exibirBotaoDetalhar = () => (
    (['detalhar-ctc', 'detalhar-ctc-invalida'].includes(this.props.statePrincipal.acao))
  );

  showModalDestinacao = () => {
    const { showModal } = { ...this.props.ctcDestinacao };

    this.props.handleChange({ value: 'incluir-destinacao', isValid: true }, 'subEstadoFormulario');
    this.props.handleChange({ value: 'incluir', isValid: true }, 'statePrincipal');
    this.props.handleChange({ value: false, isValid: true }, 'exibirBotaoIncluirInicial');
    this.props.handleChange({ value: !showModal, isValid: true }, 'showModal');
  }

  render() {
    const header = this.montaColunas();
    let listaIndexada = [];
    if(this.props.statePrincipal.ctc.destinacoes) {
      listaIndexada = this.props.statePrincipal.ctc.destinacoes.map((item, i) => {
        const itemIndexado = item;
        itemIndexado.indice = i;
        itemIndexado.indiceVisualizacao = ++i;
        itemIndexado.nomeParticipante = this.props.recuperarNomeParticipante(item);
        return itemIndexado;
      });
    }
    return (
      <React.Fragment>
        <DataGridCustom title={this.props.titulo} retirarLinhaSeparadora={this.props.retirarLinhaSeparadora}>
          <div className="row">
            <Grid cols="12 12 12 12">
              <Table
                bordered
                data={this.props.ordenarLista(listaIndexada)}
                insertRow={this.exibirBotoesPadrao()}
                options={this.options}
                listaTableHeader={header}
                pagination
                fetchInfo={this.fetchInfo}
              />
            </Grid>
          </div>
          </DataGridCustom>
      </React.Fragment>
    );
  }
}

MultiplasDestinacoes.propTypes = {
  handleChange: PropTypes.func.isRequired,
  statePrincipal: PropTypes.objectOf(PropTypes.object).isRequired,
  ctcAtividade: PropTypes.objectOf(PropTypes.object).isRequired,
  ordenarLista: PropTypes.func.isRequired,
  titulo: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  retirarLinhaSeparadora: PropTypes.bool.isRequired,
  handleCarregarAlteracaoDestinacao: PropTypes.func.isRequired,
  handleCarregarDetalhamentoDestinacao: PropTypes.func.isRequired,
  handleExcluirDestinacao: PropTypes.func.isRequired,
  recuperarNomeParticipante: PropTypes.func.isRequired,
  verificarExibicaoBotaoIncluirDestinacao: PropTypes.func.isRequired,
};

export default (MultiplasDestinacoes);



// WEBPACK FOOTER //
// ./src/pages/repositorio-ctc/templates/MultiplasDestinacoes.jsx